import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
    selector: 'app-product-overview-trend',
    templateUrl: './products-overview-trend.component.html',
    styleUrls: ['./products-overview-trend.component.css']
})
//Pagina 36
export class ProductsOverviewTrendComponent implements OnInit {
    show_results = false;

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    public indicators: IndicatorBoxModel[] = [];
    public translations: any;
    public storeError = false;
    public selectOneError: string;
    public data: QFilterModel;
    public fatturaroChart: LoyaltyChart;
    public volumeChart: LoyaltyChart;

    constructor(
        private indicatorService: IndicatorsService,
        private chartsService: IndicatorsChartService,
        private svcAnalytics: AnalyticsService,
        private srvCustomerCampaign: CustomerCampaignService,
        private translate: TranslateService,
        private searchModelFactory: SearchToolbarModelFactoryService,
    ) {

    }

    ngOnInit() {

        this.translate.get([
            'kpiChart.segmentDistribution',
            'kpiChart.selectedShop',
            'kpiChart.formatAverage',
            'kpiChart.axisTitle'
        ]).subscribe((t) => {
            this.translations = {
                segmentDistribution: t['kpiChart.segmentDistribution'],
                selectedShop: t['kpiChart.selectedShop'],
                formatAverage: t['kpiChart.formatAverage'],
                axisTitle: t['kpiChart.axisTitle']
            };
        });

        this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });

        this.initChart();
    }

    initChart() {
        this.fatturaroChart = new LoyaltyChart('line');
        this.fatturaroChart.options.legend = {layout: "horizontal", align: "center", verticalAlign: "bottom"};
        this.fatturaroChart.options.chart.zoomType = 'xy';
        this.volumeChart = new LoyaltyChart('line');
        this.volumeChart.options.legend = {layout: "horizontal", align: "center", verticalAlign: "bottom"};
        this.volumeChart.options.chart.zoomType = 'xy';
    }

    public fatturaroChartInit(data: QFilterModel) {
        this.chartsService.loadChart(this.fatturaroChart, 'products.Q184', data, this.indicatorService, this.translate);
    }

    public volumeChartInit(data: QFilterModel) {
        this.chartsService.loadChart(this.volumeChart, 'products.Q185', data, this.indicatorService, this.translate);
    }


    setChartInstance(chart: LoyaltyChart, chartInstance) {
        chart.instance = chartInstance;
    }

    searchValue(data: QFilterModel) {
        this.data = data;
        this.indicators = [];

        this.translate.get([
            'indicator.fatturato',
            'indicator.volume',
            'indicator.importo_medio_scontrino',
            'indicator.volume_medio_scontrino'
        ]).subscribe(t => {

            Observable.zip(
                this.indicatorService.indicatorCalculation('products.Q168', this.data)
            ).subscribe(
                ([Q168]) => {
                    /*168*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'fatturato')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*172*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'importo_medio_scontrino')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                    /*170*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'volume')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));
                    /*174*/
                    this.indicators.push(new IndicatorBoxModel([Q168.find(r => r.name === 'volume_medio_scontrino')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));

                });

        });

        this.fatturaroChartInit(data);
        this.volumeChartInit(data);
        this.show_results = true;
    }


    public toogleErrorStoreDialog() {
        this.storeError = !this.storeError;
    }


    resetData() {
        this.show_results = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/products/products-overview/products-overview-trend/products-overview-trend.component.ts